<list-wrapper #wrapper [mainService]="service" [panelTitle]="''" [managePerm]="auth.perm.ConsentView"
  [readPerm]="auth.perm.ConsentView" [hideAddBtn]="true" (onEdit)="editItem($event)" [customKey]="customKey">

  <div class="io-py-1">
    <div *ngFor=" let item of items$|async; last as last;" (click)="wrapper.edit(item)">
      <app-admin-kyc-log-item [item]="item"></app-admin-kyc-log-item>
    </div>
  </div>
</list-wrapper>